/**
 * Done. CPD — Landing "How We Work" Section (Stitch v2 / screen 3)
 * Vertical 5-step flow: START / CHOOSE / COMMIT / COMPLETE / CERTIFY.
 */

interface Step {
  num: string;
  title: string;
  desc: string;
  icon: string;
  filled?: boolean;
}

const STEPS: Step[] = [
  { num: '1', title: 'Start',    icon: 'edit_note',     filled: true,  desc: 'Take a quick survey so we can understand your practice and tailor your learning.' },
  { num: '2', title: 'Choose',   icon: 'auto_awesome',                  desc: 'Pick from curated learning modules matched to your goals and interests.' },
  { num: '3', title: 'Commit',   icon: 'calendar_today',                desc: 'Set one day per month. We send gentle reminders to keep you on track.' },
  { num: '4', title: 'Complete', icon: 'menu_book',                     desc: 'Work through your one-hour module, then finish with a short quiz.' },
  { num: '5', title: 'Certify',  icon: 'verified',     filled: true,    desc: 'We generate your certificate plus a draft of your outcomes and reflections — ready for your Board portal.' },
];

export function HowWeWork(): React.ReactElement {
  return (
    <section
      id="section-how"
      className="py-20 md:py-24 bg-[var(--stitch-surface)]"
    >
      <div
        className="mx-auto px-4 md:px-10 max-w-4xl text-center mb-16"
      >
        <h2 className="stitch-font-display text-[36px] md:text-[48px] text-[var(--stitch-primary)] uppercase mb-6 tracking-tight leading-tight">
          The Path to Clinical Excellence
        </h2>
        <p className="stitch-font-body text-[17px] text-[var(--stitch-on-surface-variant)] leading-relaxed italic">
          Continuing professional development, thoughtfully curated for the modern practitioner.
        </p>
      </div>

      <div className="mx-auto px-4 md:px-10 max-w-2xl relative">
        {STEPS.map((step, i) => {
          const isLast = i === STEPS.length - 1;
          return (
            <div
              key={step.num}
              className={`relative flex gap-6 md:gap-8 ${isLast ? '' : 'pb-12 md:pb-16 stitch-step-connector'} group`}
            >
              <div
                className={`z-10 flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center transition-transform duration-500 group-hover:scale-105 ${
                  step.filled
                    ? (i === STEPS.length - 1
                        ? 'bg-[var(--stitch-primary-container)] text-[var(--stitch-on-primary-container)] shadow-xl'
                        : 'bg-[var(--stitch-primary)] text-[var(--stitch-on-primary)] shadow-xl')
                    : 'border border-[var(--stitch-primary)]/20 bg-[var(--stitch-surface-container-lowest)] text-[var(--stitch-primary)] stitch-ghost-shadow group-hover:bg-[var(--stitch-primary)] group-hover:text-[var(--stitch-on-primary)]'
                }`}
                aria-hidden="true"
              >
                <span className={`material-symbols-outlined ${step.filled && i === STEPS.length - 1 ? 'is-filled' : ''}`}>
                  {step.icon}
                </span>
              </div>
              <div className="flex flex-col pt-1">
                <h3 className="stitch-font-label text-[14px] text-[var(--stitch-primary)] uppercase stitch-editorial-kerning mb-2 font-bold">
                  {step.num}. {step.title}
                </h3>
                <p className="stitch-font-body text-[15px] text-[var(--stitch-on-surface-variant)] leading-relaxed">
                  {step.desc}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
